<div class="body">
    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
        <div>
            <h1 class="title"><span>Tu</span> sesión ha expirado.</h1>
            <p class="subtitle mt-3">
                Por tu seguridad, vuelve a iniciar sesión.
            </p>
            <div class="container-btn">
                <button (click)="logOut()" class="btn bg-success me-2 ms-2">
                    Aceptar
                </button>
            </div>
        </div>
    </div>
</div>